import React, { useState, useEffect } from "react";
import Classes from "./styles/style.module.css";
import RulesImg from "../../images/joftPooch/rulesImg.png";
import CustomButton from "../../components/CustomButton";
import CustomModal from "../../components/ModalComonent";
import useIsMobile from "../../Hooks/getIsMobile";
import useLocalStorage from "../../Hooks/getLocalStorageData";
import CustomCheckBox from "../../components/CustomCheckBox";

const DownloadApplication = () => {
  const [showDownload, setShowDownload] = useState(false);
  const [isApple, setIsApple] = useState(false);
  const { fcm } = useLocalStorage();
  const isMobile = useIsMobile();

  useEffect(() => {
    checkIfon();
    if (fcm === "null" && isMobile && !isApple) {
      setShowDownload(true);
    } else {
      setShowDownload(false);
    }
  }, [fcm, isMobile, isApple]);

  const checkIfon = () => {
    const check = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    setIsApple(check);
  };

  if (JSON.parse(localStorage.getItem('showDownload')) === true) {
    return null
  }

  const banner = (
    <div className="w-100">
      <img src={RulesImg} alt="awardIcon" className={Classes.alertBanner} />
      <p className={Classes.title}>دانلود نرم‌افزار</p>
      <div className={Classes.dialogContent}>
        <p className="text-center">
          جهت تجربه کاربری هرچه بهتر، نر‌م‌افزار راه بهشت نسخه اندروید را دانلود
          کنید
        </p>
        <div className="mt-4">
          <CustomButton
            text={"نسخه اندروید"}
            color={"primary"}
            shadow={true}
            clickHandler={() => {
              setShowDownload(false);
              window.location.href =
                "https://dl.rahebehesht.com/Rahebehesht-Latest.apk";
            }}
          />
          <CustomButton
            text={"ادامه در نسخه وب"}
            color={"secondary"}
            shadow={true}
            styles={{ marginTop: "16px" }}
            clickHandler={() => {
              setShowDownload(false);
            }}
          />
          <div className="my-4">
            <CustomCheckBox handleChange={(checked) => localStorage.setItem("showDownload", checked)} value={JSON.parse(localStorage.getItem("showDownload")) || false} label={"بستن این پیام برای همیشه"} />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <CustomModal
      open={showDownload}
      closeHandler={() => {
        setShowDownload(false);
      }}
      inputDialog={true}
      dialogContent={banner}
    />
  );
};

export default DownloadApplication;
